import React from 'react';
import { Anchor } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-400 py-12 border-t border-slate-800" data-id="element-55">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-56">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8" data-id="element-57">
          {/* Brand */}
          <div className="col-span-1" data-id="element-58">
            <div className="flex items-center text-white mb-4" data-id="element-59">
              <Anchor className="h-8 w-8 text-teal-500 mr-2" data-id="element-60" />
              <span className="text-xl font-bold" data-id="element-61">Gauchos Frozen Food</span>
            </div>
            <p className="text-sm leading-relaxed max-w-xs" data-id="element-62">
              Your trusted local supplier for premium frozen seafood in Kaduna.
              Quality, freshness, and reliability guaranteed.
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-63">
            <h3 className="text-white font-semibold mb-4" data-id="element-64">Quick Links</h3>
            <ul className="space-y-2" data-id="element-65">
              <li data-id="element-66">
                <a href="#" className="hover:text-teal-400 transition-colors" data-id="element-67">
                  Home
                </a>
              </li>
              <li data-id="element-68">
                <a href="#about" className="hover:text-teal-400 transition-colors" data-id="element-69">
                  About Us
                </a>
              </li>
              <li data-id="element-70">
                <a href="#products" className="hover:text-teal-400 transition-colors" data-id="element-71">
                  Products
                </a>
              </li>
              <li data-id="element-72">
                <a href="#contact" className="hover:text-teal-400 transition-colors" data-id="element-73">
                  Contact & Location
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Small */}
          <div data-id="element-74">
            <h3 className="text-white font-semibold mb-4" data-id="element-75">Visit Us</h3>
            <address className="not-italic text-sm leading-relaxed" data-id="element-76">
              Aliyu Makama Road, Barnawa
              <br data-id="element-77" />
              Kaduna 800282
              <br data-id="element-78" />
              Kaduna, Nigeria
              <br data-id="element-79" />
              <br data-id="element-80" />
              <span className="text-teal-500" data-id="element-81">Open Daily until 8:00 PM</span>
            </address>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 text-sm text-center" data-id="element-82">
          <p data-id="element-83">
            &copy; {new Date().getFullYear()} Gauchos Frozen Food. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}